// extracted by mini-css-extract-plugin
export default {"support-icon-path":"SupportIcon_support-icon-path__9cJFY","support-icon-path-active":"SupportIcon_support-icon-path-active__ASUXU"};